import React, { Fragment } from "react"
// import ScrollAnimation from 'react-animate-on-scroll'

import clipboard from "./img/clipboard.svg"
import pen from "./img/Pen.svg"
import tablet from "./img/Tablet.svg"

const Preamble = () => (
  <Fragment>
    {/*  PREAMBLE SECTION  */}
    <section className="Preamble">
      <div className="grey-zone">
        <div className="container ">
        
          <div className="grey-list">

            <div className="box">
              <article className="greyblock">
                <div className="icon">
                  {" "}
                  <img className="img clip" src={clipboard} width="100" />{" "}
                </div>
                  <p>
                  {" "}
                  Good design is crafting the User experience in simple path to
                  push them to the things that matters most for your website.{" "}
                  </p>
                
              </article>
            </div>


            <div className="box">
              <article className="greyblock">
                <div className="icon">
                  {" "}
                  <img className="img" src={pen} width="24" />{" "}
                </div>
                <p>
                  {" "}
                  Good content enhances the direction you want to prioritize for
                  your consumers to flow thru the website experience.{" "}
                </p>
              </article>
            </div>
            <div className="box">
              <article className="greyblock">
                <div className="icon">
                  {" "}
                  <img className="img" src={tablet} width="48" />{" "}
                </div>
                <p>
                  {" "}
                  There are things that good design can clear up and implement;
                  are good visual communication and heigharchy.{" "}
                </p>
              </article>
            </div>


          </div>
        </div>
      </div>
    </section>
  </Fragment>
);
export default Preamble



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Home/components/preamble.js